<div class="bmc-blue-prism-detail-wrapper"
    *ngIf="!(isLoading$ | async) && bluePrismConnection$ | async as bluePrismConnection">
    <blue-prism-configuration [botDetail]="bluePrismConnection" (save)="onSave($event)" #bluePrismConfiguration
        (testConnection)="onTestConnection(bluePrismConnection)">
    </blue-prism-configuration>
    <hr class="bmc-bot-detail-wrapper__horizontal-rule">
</div>

<div class="bmc-blue-prism-detail-wrapper__loading-container" *ngIf="(isLoading$ | async)">
    <bzg-loading *ngIf="(isLoading$ | async)" [size]="'s'" class="bmc-blue-prism-detail-wrapper__loading">
        {{'GLOBAL.LOADING_DATA' | translate}}
    </bzg-loading>
</div>

<bots-empty *ngIf="!(bluePrismConnection$ | async) && !(isLoading$ | async)">
    {{'RPA_BOTS.EMPTY_DETAIL' | translate}}
</bots-empty>